export enum IdType {
  DEVICE_ID = 1,
  REGISTRATION_ID = 2,
};